import * as api from "../api/public";
import { START_PROGRESS, STOP_PROGRESS } from "./progress";

export const LOAD_CATALOGO_SUCCESS = "LOAD_CATALOGO_SUCCESS";
export const LOAD_CATALOGO_FAIL = "LOAD_CATALOGO_FAIL";
export const FILTRAR_PRODUTOS_POR_TAG = "FILTRAR_PRODUTOS_POR_TAG";

export const startLoading = () => ({
  type: START_PROGRESS,
});

export const stopLoading = () => ({
  type: STOP_PROGRESS,
});

// Carrega apenas os dados da loja. Os produtos são buscados paginados no GridCatalogo.
export const loadCatalogo = (username) => async (dispatch) => {
  try {
    dispatch(startLoading());

    const lojaData = await api.getLojaPorUsername(username);

    dispatch({
      type: LOAD_CATALOGO_SUCCESS,
      payload: { loja: lojaData, produtos: [] },
    });
  } catch (error) {
    console.error("Erro ao carregar catálogo: ", error);
    dispatch({
      type: LOAD_CATALOGO_FAIL,
      payload: error.message || "Erro ao carregar o catálogo.",
    });
  } finally {
    dispatch(stopLoading());
  }
};
